import { throttle } from 'lodash-es'
import { useEventListener } from '@vueuse/core'
import toast from 'fe-vui/toast'
import { isIOS, isSafari } from 'wap/hybrid/device'

window.onoffline = () => {
  toast('Please check your network connection, and try again')
}

// 解决 ios 浏览器后退页面不更新的问题
export const useReloadOnPageShow = () => {
  return useEventListener(window, 'pageshow', (event) => {
    // 解决 ios 浏览器后退页面不更新的问题
    if (event.persisted && (isIOS() || isSafari())) {
      window.location.reload()
    }
  })
}

export const useWindowResize = (onWindowResize, duration = 200) => {
  return useEventListener(window, 'resize', throttle(onWindowResize, duration))
}
